export const RECIPE_CREATE_REQUEST = 'RECIPE_CREATE_REQUEST';
export const RECIPE_CREATE_SUCCESS = 'RECIPE_CREATE_SUCCESS';
export const RECIPE_CREATE_FAIL = 'RECIPE_CREATE_FAIL';

export const RECIPE_LIST_REQUEST = 'RECIPE_LIST_REQUEST';
export const RECIPE_LIST_SUCCESS = 'RECIPE_LIST_SUCCESS';
export const RECIPE_LIST_FAIL = 'RECIPE_LIST_FAIL';

export const RECIPE_LIST_DELETE_REQUEST = 'RECIPE_LIST_DELETE_REQUEST';
export const RECIPE_LIST_DELETE_SUCCESS = 'RECIPE_LIST_DELETE_SUCCESS';
export const RECIPE_LIST_DELETE_FAIL = 'RECIPE_LIST_DELETE_FAIL';

export const RECIPE_LIST_APPEND_REQUEST = 'RECIPE_LIST_APPEND_REQUEST';
export const RECIPE_LIST_APPEND_SUCCESS = 'RECIPE_LIST_APPEND_SUCCESS';
export const RECIPE_LIST_APPEND_FAIL = 'RECIPE_LIST_APPEND_FAIL';

export const RECIPE_DETAILS_REQUEST = 'RECIPE_DETAILS_REQUEST';
export const RECIPE_DETAILS_SUCCESS = 'RECIPE_DETAILS_SUCCESS';
export const RECIPE_DETAILS_FAIL = 'RECIPE_DETAILS_FAIL';

export const RECIPE_DELETE_REQUEST = 'RECIPE_DELETE_REQUEST';
export const RECIPE_DELETE_SUCCESS = 'RECIPE_DELETE_SUCCESS';
export const RECIPE_DELETE_FAIL = 'RECIPE_DELETE_FAIL';

export const RECIPE_UPDATE_REQUEST = 'RECIPE_UPDATE_REQUEST';
export const RECIPE_UPDATE_SUCCESS = 'RECIPE_UPDATE_SUCCESS';
export const RECIPE_UPDATE_FAIL = 'RECIPE_UPDATE_FAIL';

export const RECIPE_SEARCH_LIST_REQUEST = 'RECIPE_SEARCH_LIST_REQUEST';
export const RECIPE_SEARCH_LIST_SUCCESS = 'RECIPE_SEARCH_LIST_SUCCESS';
export const RECIPE_SEARCH_LIST_FAIL = 'RECIPE_SEARCH_LIST_FAIL';
